import Supplier from '@/entities/Supplier';

export default class SupplierTransformer {
  static transformOne(item) {
    return new Supplier(item);
  }

  static transformList(items) {
    return items.map((e) => SupplierTransformer.transformOne(e));
  }
}
